import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { serverError } from './../../../../core/models/messages';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { environment } from './../../../../../environment/environment';
import { Component, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, State } from 'country-state-city';
import { translations } from '../../../../core/models/call-offer';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-archived-call-offer',
  templateUrl: './archived-call-offer.component.html',
  styleUrls: ['./archived-call-offer.component.css'],
})
export class ArchivedCallOfferComponent {
  connectedUser = this.localStorageService.getData('userConnected');
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listappeloffre: any;
  pagination : boolean =false;

  mobilities: any[] = [];
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  skillsList: { name_FR: string }[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList: any = [];
  searchForm: FormGroup = this.createSearchForm();
  sortAttr = '';

  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }

  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  status = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private appeloffreservice: EsnAppeloffreService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig

  ) {}

  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.getListappeloffrearchived();
    this.getListSkills();
    this.countries = Country.getAllCountries();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }

  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  filterColumns(columnName: string): boolean {
    return this.checkboxState[columnName]?.isChecked || false;
  }
  checkboxState: {
    [key: string]: { displayName: string; isChecked: boolean };
  } = {
    id: { displayName: 'ID', isChecked: true },
    logo: { displayName: 'logo entreprise', isChecked: true },
    societe: { displayName: 'Nom entreprise', isChecked: true },
    type: { displayName: 'Type', isChecked: true },
    poste: { displayName: 'POSTE', isChecked: true },
    dateOfPublication: { displayName: 'Date de publication', isChecked: true },
    experience: { displayName: 'Années d’expérience', isChecked: true },
    Suggestions: { displayName: 'Suggestions', isChecked: true },
    typeOfPost: { displayName: 'Type de poste', isChecked: true },
    Salaire: { displayName: 'Salaire', isChecked: true },
    TJM: { displayName: 'TJM ', isChecked: true },
    typeofContrat: { displayName: 'Type de contrat', isChecked: true },
    skills: { displayName: 'Compétences', isChecked: true },
    pays: { displayName: 'Pays ', isChecked: true },
    ville: { displayName: 'Ville ', isChecked: true },
    state: { displayName: 'Statut ', isChecked: true },
  };

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    this.sortAttr = item;
    //    if(this.searchForm.value!='') this.listappeloffre = this.sortDataService.sortArray(this.listappeloffre, this.sortAttr, this.currentSortDirection)
    // else
    this.getListappeloffrearchived();
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchappeloffre();
      } else 
      if( (this.startIndex !=0 ||this.endIndex) || this.pagination == true){
        this.pagination = true
        this.getListappeloffrearchived();
      }
    }
  }
  translateCountryName(name: string): string {
  
    return translations[name] || name;
  }
  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          } else {
          }
        }
      }
    });

    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);
  
        });
      }*/
    }
  }
  getCheckboxStateEntries(): [
    string,
    { displayName: string; isChecked: boolean }
  ][] {
    return Object.entries(this.checkboxState);
  }
  updateCheckboxState(columnName: string): void {
    const checkbox = this.checkboxState[columnName];
    if (checkbox) {
      checkbox.isChecked = !checkbox.isChecked;
    }
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  getListappeloffrearchived() {
    let dataPyload =
      this.sortAttr == ''
        ? {
            id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.spinner.show();
    this.appeloffreservice.getListappeloffrearchived(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listappeloffre = response.data.data;
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobRequest: ['', data?.ID_jobRequest],
      name: ['', data?.name],
      client_final_name: ['', data?.client_final_name],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      contract_type: [[], data?.contract_type],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      post_type: [[], data?.post_type],
      city: [[], data?.city],
      country: [[], data?.country],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      state: [null, data?.state],
      profile_abroad: [null, data?.profile_abroad],
    });
  }
  /* search */
  searchappeloffre(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');

    let data = {
      id: this.idclientConnected,
      ID_jobRequest: valueForm.ID_jobRequest,
      name: valueForm.name,
      client_final_name: valueForm.client_final_name,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      search: this.transformSearch(valueForm?.search),
      contract_type: valueForm.contract_type,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      post_type: valueForm.post_type,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      city: valueForm.city,
      country: valueForm.country,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      state: valueForm.state,
      profile_abroad: valueForm.profile_abroad,
      per_page: this.itemsPerPage,
      page: pageNumber,
    };

    this.spinner.show();
    this.appeloffreservice.searchappeloffrearchived(data).subscribe({
      next: (resSearch) => {
        if(this.startSearching == true) {
          this.currentPage = 1;
          this.startSearching = false;
        }      
        this.listappeloffre = resSearch.data.data.slice(0, this.endIndex);
        this.totalItems = resSearch.data.total;
        this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }

  restaurerappeloffre(id: any) {
    Swal.fire({
      title: 'Vous êtes sûr de restaurer l’offre sélectionnée ?',

      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, restaurer !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.appeloffreservice
          .restaurerappeloffre(id, this.idclientConnected)
          .subscribe({
            next: (response: any) => {
              if (response.data) {
                this.toastrService.success(
                  'L’appel d’offre a été restauré avec succès.'
                );
                this.searchappeloffre();
              }
            },
            error: (error: any) => {
            },
          });
      }
    });
  }
  reset() {
    this.stateList=[];
    this.currentPage = 1;
    this.endIndex = 5;
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.getListappeloffrearchived();
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
}
